import Menu from "configurator-studio-arkitekter-components/dist/common/components/Menu";

export default Menu;
